<template>
	<div id="app">
		<Header></Header>
		<router-view />
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from './components/header.vue'
	import Footer from './components/footer.vue'
	import http from '@/request/api'
	export default {
		name: 'App',
		data() {
			return {
				initTimeStr: new Date().getTime(),
			}
		},
		components: {
			Header,
			Footer,
		},
		created() {
			this.onWebsiteBrowsing()
		},
		methods: {
			generateUUID32() {
				return crypto.randomUUID().replace(/-/g, '').substring(0, 32)
			},
			async onWebsiteBrowsing() {
				const { data } = await http.websiteBrowsing({
					actionTime: new Date().getTime(),
					deviceUniqueId: this.generateUUID32(),

					eventName: 'website_browsing',
					firstVisitTime: new Date().getTime() - this.initTimeStr,
				})
			},
		},
	}
</script>

<style>
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}
	html {
		min-width: 1188px;
	}
</style>
